import { CLOSE_DATE, SECOND_CLOSE_DATE, ABBREV_TIME_ZONE } from '../utils/Constants'
import { Table } from 'antd'
import React from 'react'

const dataSource = [
  {
    key: 1,
    name: 'Round of 32',
    primary: 1,
    secondary: 0,
  }, {
    key: 2,
    name: 'Round of 16',
    primary: 2,
    secondary: 2,
  }, {
    key: 3,
    name: 'Quarter finals',
    primary: 4,
    secondary: 4,
  }, {
    key: 4,
    name: 'Semi finals',
    primary: 8,
    secondary: 8,
  }, {
    key: 5,
    name: 'Finals',
    primary: 16,
    secondary: 16,
  }, {
    key: 6,
    name: 'Third place',
    primary: 24,
    secondary: 24,
  }, {
    key: 7,
    name: 'Winner',
    primary: 32,
    secondary: 32,
  }, {
    key: 8,
    name: 'Total possible',
    primary: 216,
    secondary: 184,
  },
]

const columns = [
  {
    title: undefined,
    dataIndex: 'name',
    key: 'name'
  }, {
    title: (<div className="score-table-header">
      <h3>Main brackets <span>Group Stage</span></h3>
      <p>{`Deadline: ${CLOSE_DATE.human} ${ABBREV_TIME_ZONE}`}</p>
    </div>),
    dataIndex: 'primary',
    key: 'primary'
  }, {
    title: (<div className="score-table-header">
      <h3>Second chance brackets <span>Knockout Stage</span></h3>
      <p>{`Deadline: ${SECOND_CLOSE_DATE.human} ${ABBREV_TIME_ZONE}`}</p>
    </div>),
    dataIndex: 'secondary',
    key: 'secondary'
  },
]

export default function ScoringTable() {
  return (
    <Table
      dataSource={dataSource}
      columns={columns}
      pagination={{ hideOnSinglePage: true }}
      className="scoring-table"
    />
  )
}
